import { AxiosError } from 'axios'
import useSWR from 'swr'

import { fetchAttributeOptions } from 'api'
import {
  FilterableEntity,
  FilterConfigAndAvailableValues,
  FilterValueType} from 'context/filtersContext'

const formatOptions = (options?: string[]) =>
  options?.map((option: string) => ({ value: option, label: option })) || []

export default function(filter: FilterConfigAndAvailableValues): any[] {
  if (
    filter.valueType === FilterValueType.STRING &&
    filter.attributeType === FilterValueType.STRING &&
    filter.filterType === FilterableEntity.CUSTOM_ATTRIBUTE
  ) {
    const attributeKey = filter.filterDisplayName
    const { data } = useSWR<string[], AxiosError>(
      ['/v2/accounts/attribute_options', attributeKey],
      async () => {
        const { data } = await fetchAttributeOptions(attributeKey)
        return data
      }
    )

    return formatOptions(data)
  }
  return filter.values
}
